<div class="flex flex-col h-screen">
  <!-- Top Bar -->
  <header class="bg-white border-b border-gray-200 h-16 sticky top-0 z-10">
    <div class="flex items-center justify-between h-full max-w-7xl mx-auto px-4">
      <div class="flex items-center gap-4">
        <img src="/Logo.png" alt="Logo" class="h-10">
        <app-plugin-header-nav></app-plugin-header-nav>
      </div>

      <div class="flex items-center gap-4">
        @if (currentUser) {
          <app-user-dropdown
            [user]="currentUser"
            (profileClick)="openProfile()"
            (logoutClick)="logout()">
          </app-user-dropdown>
        }
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <!-- h-full on the inner wrapper: without it a routed page cannot fill the viewport, so a page that
       pins its actions to the bottom (the plugin settings page) collapses to its content height. -->
  <main class="flex-1 overflow-y-auto bg-white p-4">
    <div class="max-w-7xl mx-auto h-full">
      <router-outlet></router-outlet>
    </div>
  </main>

  <!-- User Profile Modal -->
  <p-dialog
    header="My Profile"
    [(visible)]="showProfileModal"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    styleClass="w-full max-w-2xl">
    <app-user-profile
      [user]="currentUser"
      (close)="closeProfile()"
      (save)="saveProfile()"
      (logout)="logout()">
    </app-user-profile>
  </p-dialog>
</div>